<template>
  <div>
    <div class="index-top">
      <layout-header :is-transparent="true"></layout-header>
<!--      <div class="index-top-content">-->
<!--        <div class="index-top-line"></div>-->
<!--        <div class="index-top-title">-->
<!--          <h2 class="main-title">皇家加勒比集团</h2>-->
<!--          <h2 class="sub-title">媒体与新闻中心</h2>-->
<!--          <div class="sub-title-en">Royal Caribbean Media Center</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <div v-if="articleLists && articleLists.length > 0" class="list-model">
      <div class="list-model-title">
        <h3 class="title-zh">最近新闻</h3>
        <div class="title-en">Latest News</div>
      </div>
      <router-link to="/Rccl.CustomPage/MediaCenter/ManuscriptDownload" class="list-model-more">
        <span class="txt">更多文稿</span>
        <img class="icon" :src="morePic"/>
      </router-link>
      <news-list :list="articleLists" :is-sub-page="false"></news-list>
    </div>

    <div v-if="imageLists && imageLists.length > 0" class="list-model bc-top">
      <div class="list-model-title">
        <h3 class="title-zh">最新图片</h3>
        <div class="title-en">Latest Images</div>
      </div>
      <router-link to="/Rccl.CustomPage/MediaCenter/ImagesDownload" class="list-model-more">
        <span class="txt">更多图片</span>
        <img class="icon" :src="morePic"/>
      </router-link>
      <images-list :list="imageLists" :is-sub-page="false"></images-list>
    </div>

    <div v-if="videoLists && videoLists.length > 0" class="list-model bc-top mar-top">
      <div class="list-model-title">
        <h3 class="title-zh">最新视频</h3>
        <div class="title-en">Latest Videos</div>
      </div>
      <router-link to="/Rccl.CustomPage/MediaCenter/VideosDownload" class="list-model-more">
        <span class="txt">更多视频</span>
        <img class="icon" :src="morePic"/>
      </router-link>
      <videos-list :list="videoLists" :is-sub-page="false"></videos-list>
    </div>

    <div class="layout-bottom"></div>
  </div>
</template>

<script>
import LayoutHeader from "@/layout/MediaCenter/components/LayoutHeader";
import apiMc from "@/api/MediaCenter";
import NewsList from "@/components/MediaCenter/NewsList";
import ImagesList from "../../components/MediaCenter/ImagesList";
import VideosList from "../../components/MediaCenter/VideosList";
export default {
  name: "Index",
  components: {VideosList, ImagesList, NewsList, LayoutHeader},
  data() {
    return {
      morePic: require("@/assets/MediaCenter/more.png"),
      imageLists: [],
      articleLists: [],
      videoLists: []
    }
  },
  created() {
    this.getRows();
  },
  methods: {
    async getRows() {
      this.$loading.show();
      const { success, data, errMsg } = await apiMc.newsFileList.getHomeContent();
      if(success) {
        this.articleLists = data.articleLists;
        this.imageLists = this.formatRows(data.imageLists);
        this.videoLists = this.formatRows(data.videoLists);
      } else {
        console.log(errMsg);
      }
      this.$loading.hide();
    },
    formatRows(rows) {
      rows && rows.forEach((row)=>{
        row.isFold = false;
      });
      return rows;
    }
  }
}
</script>

<style lang="less" scoped>
.index-top {
  position: relative;
  width: 100%;
  height: 440px;
  background-image: url('../../assets/MediaCenter/index_bg.jpg');
  background-size: 100%;
}
.index-top-line {
  height: 6.5px;
  font-size: 0;
  width: 219.5px;
  margin-top: 122px;
  background-color: rgb(207, 186, 116);
}
.index-top-title {
  width: 180px;
  margin-top: 21px;
  margin-left: 26px;
  text-align: justify;
  text-align-last: justify;
  text-justify: inter-ideograph;
  color: #ffffff;
  & .main-title {
    font-size: 1.2rem;
    font-weight: normal;
    
  }
  & .sub-title {
    font-size: 1.2rem;
    font-weight: 600;
    
    margin-top: 5px;
  }
  & .sub-title-en {
    font-size: .7rem;
    font-weight: normal;
    margin-top: 5px;
    letter-spacing: -1px;
  }
}
</style>
